import { GET_CONSTITUENCIES_FAIL, GET_CONSTITUENCIES_SUCCESS, GET_COUNTIES_FAIL, GET_COUNTIES_SUCCESS, GET_REGIONS_FAIL, GET_REGIONS_SUCCESS, GET_WARDS_FAIL, GET_WARDS_SUCCESS } from './actionTypes';

const INIT_STATE = {
  counties: [],
  constituencies: [],
  wards: [],
  regions: [],
  error: {},
  loading: true,
};

const Location = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_REGIONS_SUCCESS:
      return {
        ...state,
        regions: action.payload,
        loading: false,
      };

    case GET_REGIONS_FAIL:
    case GET_COUNTIES_FAIL:
    case GET_CONSTITUENCIES_FAIL:
    case GET_WARDS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_COUNTIES_SUCCESS:
      return {
        ...state,
        counties: action.payload,
        loading: false,
      };

    case GET_CONSTITUENCIES_SUCCESS:
      return {
        ...state,
        constituencies: action.payload,
        loading: false,
      };
    case GET_WARDS_SUCCESS:
      return {
        ...state,
        wards: action.payload,
        loading: false,
      };

    default:
      return state;
  }
};

export default Location;
